module.exports = __webpack_public_path__ + "img/icon_book.b3ff39ee.svg";